var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayerUi01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 0.75px;\n      }\n\n      .cls-2 {\n        stroke-linecap: round;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Player ui") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M21.64,22a.16.16,0,0,1-.09.16.21.21,0,0,1-.19,0L5.06,12.77A.18.18,0,0,1,5,12.52a.11.11,0,0,1,.08-.08l16.3-9.39h.19a.16.16,0,0,1,.09.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1.77,23.31V1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerUi01);
export default __webpack_public_path__ + "static/media/Player_ui_01.d8bdf271eb9e7978dabc480d5615a164.svg";
export { ForwardRef as ReactComponent };